<template>
  <vs-input
    v-uppercase
    v-model="model"
    class="w-full bg-white"
    v-mask="'####################'"
    :readonly="readonly"
    :icon="icon"
    :icon-pack="iconPack"
    :name="name"
    :label-placeholder="labelPlaceholder"
    :autocomplete="autocomplete"
    v-on:keyup.enter="enterEvent"
    @input="$emit('input', model)"
  ></vs-input>
</template>

<script>
export default {
  name: "number-input",
  props: {
    value: String,
    name: String,
    autocomplete: String,
    readonly: {
      type: Boolean,
      default: false
    },
    labelPlaceholder: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconPack: {
      type: String,
      default: null
    },
    enterEvent: {
      type: Function,
      default: () => {}
    }
  },
  data: () => {
    return {
      model: null
    };
  },
  created() {
    this.model = this.value;
  },
  watch: {
    value(value) {
      this.model = value;
    }
  }
};
</script>
